export default __webpack_public_path__ + "static/media/bg7.7a0bcacb.png";